export const ADDRESS_CREATE_RESET = 'ADDRESS_CREATE_RESET'
export const ADDRESS_CREATE_SET_CREATED = 'ADDRESS_CREATE_SET_CREATED'
export const ADDRESS_CREATE_SET_ERROR = 'ADDRESS_CREATE_SET_ERROR'
export const ADDRESS_CREATE_SET_VIOLATIONS = 'ADDRESS_CREATE_SET_VIOLATIONS'
export const ADDRESS_CREATE_TOGGLE_LOADING = 'ADDRESS_CREATE_TOGGLE_LOADING'
